import { ReactElement, useMemo } from 'react';
import styles from './task-info-item.module.scss';
import { UIErrorState } from '@/ui';
import { TaskInfoItem, TaskInfoItemProps } from './task-info-item';
import { useTaskBeaconSnapshot } from '../providers';
import { useTasksTranslation } from '../hooks';

export function TaskBeaconsList(): ReactElement {
    const { t } = useTasksTranslation();
    const { beacons } = useTaskBeaconSnapshot();

    const items: TaskInfoItemProps[] = useMemo(() => {
        return beacons.map((beacon, index) => {
            return {
                title: t('shared.tasks.beacon_name_with_distance', {
                    name: beacon.name,
                    distance: beacon.distanceMeters
                }),
                tags: beacon.tags.map((tag) => ({ text: tag })),
                listNumber: index + 1
            };
        });
    }, [beacons, t]);

    return (
        <div className={styles.container}>
            <div className={styles.listContainer}>
                {items.map((props, index) => (
                    <TaskInfoItem key={index} {...props} />
                ))}
                {items.length === 0 && (
                    <UIErrorState
                        title={t('components.task_beacons_list.empty')}
                    />
                )}
            </div>
        </div>
    );
}
